'use client';
import { WebUrlType } from '@api/v3';
import { createGenericContext } from '@contexts/generateContext';

const [useResourceId, ResourceIdProvider] = createGenericContext<string>();
const [useSsrData, SsrDataProvider] = createGenericContext();
const [useSearchURL, SearchURLProvider] = createGenericContext<{
  type: WebUrlType;
  text: string;
  id: number;
  url: string;
}>();

export {
  useResourceId,
  ResourceIdProvider,
  useSsrData,
  SsrDataProvider,
  useSearchURL,
  SearchURLProvider,
};
